import React from 'react';
import _ from 'lodash';

import useProductQueryParams from 'hooks/use-product-query-params';
import { SubcategoryPillButton, SubcategoryPillContainer } from './styles';

type MultiSelectSubcategoryPillProps = {
  isSubcategory?: boolean;
  label: string;
  value: string;
  selected: boolean;
  selectedSubcategories: string[];
};

export const MultiSelectSubcategoryPill = ({
  isSubcategory = false,
  label,
  value,
  selected,
  selectedSubcategories,
}: MultiSelectSubcategoryPillProps): JSX.Element => {
  const { defaults, setQueryParams } = useProductQueryParams();

  const newSubcategories = isSubcategory ? _.xor(selectedSubcategories, [value]) : defaults.subcategories;

  const handleMultiSelectClick = (): void => {
    setQueryParams({ subcategories: newSubcategories, page: defaults.page });
  };

  return (
    <SubcategoryPillContainer>
      <SubcategoryPillButton selected={selected} onClick={handleMultiSelectClick}>
        {label}
      </SubcategoryPillButton>
    </SubcategoryPillContainer>
  );
};
